import { Control, FieldErrors } from "react-hook-form";
import { RegionChipSelect } from "@/components/RegionChipSelect/RegionChipSelect";
import { ProviderField } from "./ProviderField";
import { TagsHierarchyV2, TagTypeTagV2 } from "@/types/tagsV2";
import { UserV2FormValues } from "./UserFormV2";
import { MarketsAutocomplete } from "@/components/MarketsAutocomplete";

interface Mk2FastFormPartProps {
  isProviderInventoryManager: boolean;
  control: Control<UserV2FormValues>;
  errors: FieldErrors<UserV2FormValues>;
  providerOptions: TagTypeTagV2[];
  getDefaultProviderValue: () => string | undefined;
  regionOptions: { label: string; value: number }[];
  handleRegionsChange: (selectedRegions: number[]) => void;
  currentTags: number[];
  markets: TagsHierarchyV2[] | undefined;
  handleAgileMarketsChange: (selectedMarketTags: number[]) => void;
  currentAgileMarketTags: number[];
  disabled: boolean;
  isMarketsLoading: boolean;
  isRegionsLoading: boolean;
  index: number;
}

export const Mk2FastFormPart = ({
  isProviderInventoryManager,
  control,
  errors,
  providerOptions,
  getDefaultProviderValue,
  regionOptions,
  handleRegionsChange,
  currentTags,
  markets,
  handleAgileMarketsChange,
  currentAgileMarketTags,
  disabled,
  isMarketsLoading,
  isRegionsLoading,
  index,
}: Mk2FastFormPartProps) => {
  return (
    <>
      {isProviderInventoryManager && (
        <ProviderField
          control={control}
          errors={errors}
          providerOptions={providerOptions}
          defaultValue={getDefaultProviderValue()}
        />
      )}
      <RegionChipSelect
        regions={regionOptions}
        onChange={handleRegionsChange}
        error={!!errors.roles?.[index]?.regionTags}
        helperText={errors.roles?.[index]?.regionTags?.message}
        value={currentTags}
        loading={isRegionsLoading}
      />
      <MarketsAutocomplete
        data={markets}
        handleMarketsChange={handleAgileMarketsChange}
        currentMarketTags={currentAgileMarketTags}
        error={!!errors.roles?.[index]?.marketTags}
        helperText={errors.roles?.[index]?.marketTags?.message}
        disabled={disabled}
        loading={isMarketsLoading}
      />
    </>
  );
};
